import { mapActions, mapMutations } from 'vuex'
import maInputText from '@/components/input/modules/text'
import maOtpInput from '@/components/input/modules/otp'
import maConfrimBtn from '@/components/button-blue'
import maModal from '@/components/modal'
import vOtpInput from '@bachdgvn/vue-otp-input'
import userLoginMixin from '@/modules/User/mixins/userLoginMixin'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { apiPostValidateOtp } from '@/modules/User/services/authentication'
import { apiGetDamage } from '@/modules/Damage/services/damages'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_UPDATE_SINISTER_SUMMARY
} from '@/store/types'
import { FLOW_MODULE_NAME, FLOW_SET_ERROR } from '@/modules/Flow/store/types'
import { prepareErrorForSentry } from '@/utils/errorHandling'
import { errorsTrack } from '@/utils/registeredErrors'

/**
 * @module
 * @name Otp
 */
export default {
  name: 'otp',
  mixins: [userLoginMixin, flowMixin],
  data: function() {
    return {
      loading: false,
      otpValCode: '',
      inputsNumber: 6,
      clipboardData: null,
      keyBoadKey: null,
      navbar: document.querySelector('.nav-bar'),
      isBPCE: false,
      isE2EUserType: false
    }
  },
  computed: {
    getPhone() {
      // pedir que envien correo o teléfono según se genere en mavalue
      // imlementar getEmail y usar en la pantalla
      if (sessionStorage.getItem('telephone')) {
        const phoneNumber = sessionStorage.getItem('telephone')
        return `xx xx xx${phoneNumber.substring(0, 2)}${phoneNumber.substring(
          2,
          4
        )} `
      } else {
        return ''
      }
    },
    getBtnType() {
      return this.loading ? 'spinnerBtn' : 'functionalBtnWhite'
    },

    async initI18n() {
      return this.initI18n('lang')
    },

    isDisabledButton() {
      return this.otpValCode.length < this.inputsNumber
    }
  },
  components: {
    maInputText,
    maConfrimBtn,
    maModal,
    vOtpInput,
    maOtpInput
  },
  created() {
    // window.addEventListener('resize', this.checkWindowResize)
  },
  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyUpdateSinisterSummary: WARRANTY_UPDATE_SINISTER_SUMMARY
    }),

    ...mapActions(FLOW_MODULE_NAME, {
      actFlowSetError: FLOW_SET_ERROR
    }),

    async handleValidateOtp() {
      // Validate OTP against API and set token in local storage if its valid
      this.loading = true

      try {
        const sinisterID = sessionStorage.getItem('sinId')
        const token = await apiPostValidateOtp(sinisterID, this.otpValCode)

        if (token) {
          sessionStorage.setItem('otpCode', this.otpValCode)
          sessionStorage.setItem('mavAuth', `Token ${token.token}`)
          sessionStorage.setItem('renewToken', 'false')

          await this.getUserData()
          await this.trackFlowStart()
          await apiGetDamage(this.getSinisterId).then((damages) => {
            this.mutWarrantyUpdateSinisterSummary(damages)
          })

          sessionStorage.setItem('user', 'scuser')

          this.$router
            .push({
              name: 'claim-home',
              query: { ...this.$route.query }
            })
            .catch((e) => {})

          this.loading = true
          this.navbar.classList.remove('hidden')
        } else {
          const messageNotification = this.$t('otpView.text.errorNotification')
          this.throwNotification(messageNotification, messageNotification, 'KO')
          this.loading = false
          return false
        }
      } catch (e) {
        // Check that error is not in the array already
        const errorStr = `${e.message} on handleValidateOtp - ${this.$t('otpView.text.errorNotification')}`
        if (!errorsTrack.includes(errorStr)) errorsTrack.push(errorStr)

        // Create error context tags
        const context = {
          component: 'otp',
          method: 'handleValidateOtp',
          route: this.$route.path
        }
        const tags = prepareErrorForSentry(e, context)

        if (e.response.status >= 500 && e.response.status < 600) {
          this.sendSentryError(e.message, 'error', tags, this.$route.query.sinisterId, 'handleValidateOtp')
        }

        const messageNotification = this.$t('otpView.text.errorNotification')
        this.throwNotification(messageNotification, messageNotification, 'KO')
        this.loading = false

        return false
      }
    },

    async handleResendSMS() {
      this.loading = true
      /* this.sendSentryEvent(
                  'User requested new verification code',
                  this.handleResendSMS.name
                ) */

      const encSinisterId = this.$route.query.sinisterId
      try {
        await this.getOtpStatus(encSinisterId)
      } catch (e) {
        // Check that error is not in the array already
        const errorStr = `${e.message} on handleResendSMS`
        if (!errorsTrack.includes(errorStr)) errorsTrack.push(errorStr)

        // Create error context tags
        const context = {
          component: 'otp',
          method: 'handleResendSMS',
          route: this.$route.path
        }
        const tags = prepareErrorForSentry(e, context)

        const err = e.response.status >= 500 && e.response.status < 600 ? 'error' : 'warning'
        this.sendSentryError(e.message, err, tags, this.$route.query.sinisterId, 'handleResendSMS')

        this.actFlowSetError(e.response.data.message)
      }

      this.loading = false
    },

    handleOnChange(value) {
      this.otpValCode = value
    },
    checkWindowResize(e) {
      window.scrollTo(0, 0)
    },
    openInfoModal() {
      this.$refs.modalInfoOtp.showModal = true

      if (this.$refs.modalInfoOtp.showModal) {
        // Send sentry custom event
        /* this.sendSentryEvent('User opened otp modal', this.openInfoModal.name) */
      }
    },
    trackFlowStartSendOtp() {
      const startTrackMessage = `Selfcare - Send Otp`
      this.trackUserFlowTimeStamp(startTrackMessage, this.getSinisterId)
    },
    trackFlowStart() {
      const startTrackMessage = `Selfcare - Try login`
      this.trackUserFlowTimeStamp(startTrackMessage, this.getSinisterId)
    },
    handleInputPaste() {
      const otpContent = this.$refs.otpCode.$el
      const otpContainer = this.$refs.otpCode

      // Need the key to difference if user write the code o paste.
      otpContent.addEventListener('keydown', (event) => {
        this.keyBoadKey = event.keyCode
      })

      const otpLength = 1
      const key = 229

      const firstNumberCode = otpContainer.otp[0]
      // when copying from the keyboard only pastes one value, so first check if the value of otp is only one and pass the information to the handleOnPaste event of the library. SOMETHING WE HAVE TO TEST
      if (otpContainer.otp.length === otpLength && this.keyBoadKey === key) {
        navigator.clipboard
          .readText()
          .then((code) => {
            const regex = /^[0-9]*$/
            const number = regex.test(code)
            const firstChaptCode = code.charAt(0)
            if (
              code.length === this.inputsNumber &&
              firstNumberCode === firstChaptCode &&
              number
            ) {
              this.clipboardData = code.substring(1)
            }

            otpContainer.handleOnPaste({
              clipboardData: { getData: () => this.clipboardData },
              preventDefault: () => {}
            })

            this.clipboardData = null
          })
          .catch((err) => {
            console.error('Failed to read clipboard contents: ', err)
          })
      }
    },
    hiddenNavbar() {
      if (this.$route.name === 'otp') {
        this.navbar.classList.add('hidden')
      }
    }
  },

  mounted() {
    const userType = this.$route.query.user_type
    if (userType === 'billma_bpce') {
      this.isBPCE = true
    } else if (userType === 'e2e') {
      this.isE2EUserType = true
    }
    this.hiddenNavbar()
    this.notifyAppOfChanges(this)
  }
}
